import * as afoDocsSelectors from './afoDocsSelectors';

export const getSelectedEventId = state => state.eventId;
export const isSelectedEventLoading = state => state.isLoading;

export const getSelectedEventAfoDocs = state => afoDocsSelectors.getAfoDocs(state.afo);
export const isAfoDocsLoading = state => afoDocsSelectors.getIsLoading(state.afo);
